import React from 'react';
import { ShieldAlert, ArrowLeft, LogOut } from 'lucide-react';
import { Button } from '../components/Button';
import { useNavigate } from 'react-router-dom';
export default function PermissionDenied() {
  const navigate = useNavigate();
  const role = localStorage.getItem('bimcs_role') || 'Tidak Diketahui';
  return <div className="min-h-screen bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] bg-repeat bg-background flex items-center justify-center p-4 relative" data-id="element-2605">
      <div className="absolute inset-0 bg-gradient-to-b from-background/80 to-background pointer-events-none -z-10" data-id="element-2606"></div>
      <div className="max-w-md w-full glass-panel-heavy border-destructive/30 p-8 text-center space-y-6 animate-in fade-in zoom-in duration-500" data-id="element-2607">
        <div className="w-20 h-20 mx-auto bg-destructive/10 rounded-full flex items-center justify-center border border-destructive/30" data-id="element-2608">
          <ShieldAlert className="w-10 h-10 text-destructive" data-id="element-2609" />
        </div>
        <div className="space-y-2" data-id="element-2610">
          <h1 className="text-2xl font-heading font-bold text-destructive tracking-widest uppercase text-glow-destructive" data-id="element-2611">
            Akses Ditolak
          </h1>
          <p className="text-sm font-mono text-muted-foreground" data-id="element-2612">
            Kredensial Anda tidak memiliki otorisasi yang cukup untuk mengakses
            modul ini. Insiden ini telah dicatat dalam log audit keamanan.
          </p>
        </div>
        <div className="bg-black/40 border border-border/50 rounded p-3 text-left space-y-1" data-id="element-2613">
          <div className="flex justify-between text-[10px] font-mono" data-id="element-2614">
            <span className="text-muted-foreground uppercase tracking-widest" data-id="element-2615">
              Peran Aktif
            </span>
            <span className="text-foreground" data-id="element-2616">{role}</span>
          </div>
          <div className="flex justify-between text-[10px] font-mono" data-id="element-2617">
            <span className="text-muted-foreground uppercase tracking-widest" data-id="element-2618">
              Modul Diminta
            </span>
            <span className="text-destructive break-all" data-id="element-2619">
              {window.location.pathname}
            </span>
          </div>
        </div>
        <div className="space-y-2" data-id="element-2620">
          <Button onClick={() => navigate('/')} className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-mono text-xs tracking-widest uppercase" data-id="element-2621">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-2622" />
            Kembali ke Beranda
          </Button>
          <Button variant="outline" onClick={() => navigate('/login')} className="w-full border-border/50 font-mono text-xs tracking-widest uppercase text-muted-foreground hover:text-destructive hover:border-destructive/50" data-id="element-2623">
            <LogOut className="w-4 h-4 mr-2" data-id="element-2624" />
            Keluar
          </Button>
        </div>
      </div>
    </div>;
}